import {combineReducers} from 'redux';
import {managementReducer} from './management';

export const referralsReducer = combineReducers({
  management: managementReducer,
});
